import styled from 'styled-components'

export const CmtForm = styled.form`
    display: flex;
    flex-direction: column;
    margin-top: ${({reply}) => reply ? '10px':''};
`

export const FormInput = styled.textarea`
    outline: none;
    background-color: #fff;
    box-shadow: inset 0 1px 3px 0 rgb(0 0 0 / 19%);
    border: solid 1px #c89490;
    height: ${({reply}) => reply ? '50px':'76px'};
    padding: 12px;
    color: #727b88;
    width: 100%;
    font: normal 14px/1.29 Roboto;
    resize: none;

    @media screen and (max-width: 767px) {
        height: 60px;
    }
`

export const FormSubmit = styled.button`
    outline: none;
    border-radius: 2px;
    background-color: ${({reply}) => reply ? '#4e4e4e':'#e32'};
    padding: ${({reply}) => reply ? '6px 12px':'8px 14px'};
    font-size: 12px;
    margin-top: 6px;
    border: none;
    align-self: flex-start;
    color: #fff;
    cursor: pointer;
    margin-left: ${({reply}) => reply ? 'auto':''};

    @media screen and (max-width: 767px) {
        padding: 6px 12px;
    }
`